var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.filtertype,{tag:"component",attrs:{"id":_vm.id,"is-multiple":_vm.isMultiple,"value":_vm.value,"disabled":_vm.disabled,"enumeration":_vm.enumeration},on:{"change":_vm.change}})
}
var staticRenderFns = []

export { render, staticRenderFns }